import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
  variant?: 'default' | 'horizontal' | 'compact';
}

export default function ArticleCard({ article, variant = 'default' }: ArticleCardProps) {
  if (variant === 'compact') {
    return (
      <Link
        to={`/article/${article.id}`}
        className="group block p-4 bg-background-50 rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
      >
        <div className="flex gap-4">
          <div className="w-20 h-20 shrink-0 rounded-lg overflow-hidden bg-background-200">
            <img
              src={article.imageUrl}
              alt={article.title}
              className="w-full h-full object-cover"
              title={`${article.title} - 爆料网`}
            />
          </div>
          <div className="flex-1 min-w-0">
            <h4 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 leading-snug">
              {article.title}
            </h4>
            <div className="flex items-center gap-3 mt-2 text-xs text-foreground-500">
              <span>{article.publishedAt}</span>
              <span>{article.viewCount.toLocaleString()} 阅读</span>
            </div>
          </div>
        </div>
      </Link>
    );
  }

  if (variant === 'horizontal') {
    return (
      <Link
        to={`/article/${article.id}`}
        className="group flex flex-col sm:flex-row gap-5 p-5 bg-background-50 rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
      >
        <div className="w-full sm:w-56 h-40 shrink-0 rounded-lg overflow-hidden bg-background-200">
          <img
            src={article.imageUrl}
            alt={article.title}
            className="w-full h-full object-cover"
            title={`${article.title} - 爆料网`}
          />
        </div>
        <div className="flex-1 min-w-0 flex flex-col justify-between">
          <div>
            <div className="flex items-center gap-2 mb-2">
              {article.isExclusive && (
                <span className="px-2 py-0.5 text-xs font-medium bg-accent-100 text-accent-800 rounded-full">
                  独家
                </span>
              )}
              {article.isHot && (
                <span className="px-2 py-0.5 text-xs font-medium bg-primary-100 text-primary-700 rounded-full">
                  热门
                </span>
              )}
            </div>
            <h3 className="text-lg font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 leading-snug">
              {article.title}
            </h3>
            <p className="text-sm text-foreground-600 mt-2 line-clamp-2 leading-relaxed">
              {article.excerpt}
            </p>
          </div>
          <div className="flex items-center gap-4 mt-3 text-xs text-foreground-500">
            <span className="flex items-center gap-1">
              <i className="ri-time-line"></i>
              {article.readTime} 分钟阅读
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {article.viewCount.toLocaleString()}
            </span>
            <span>{article.publishedAt}</span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/article/${article.id}`}
      className="group block bg-background-50 rounded-lg overflow-hidden hover:bg-background-100 transition-colors cursor-pointer h-full"
    >
      <div className="h-48 overflow-hidden bg-background-200">
        <img
          src={article.imageUrl}
          alt={article.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          title={`${article.title} - 爆料网`}
        />
      </div>
      <div className="p-5">
        <div className="flex items-center gap-2 mb-2">
          {article.isExclusive && (
            <span className="px-2 py-0.5 text-xs font-medium bg-accent-100 text-accent-800 rounded-full">
              独家
            </span>
          )}
          {article.isHot && (
            <span className="px-2 py-0.5 text-xs font-medium bg-primary-100 text-primary-700 rounded-full">
              热门
            </span>
          )}
        </div>
        <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 leading-snug">
          {article.title}
        </h3>
        <p className="text-sm text-foreground-600 mt-2 line-clamp-2 leading-relaxed">
          {article.excerpt}
        </p>
        <div className="flex items-center gap-3 mt-4 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-time-line"></i>
            {article.readTime} 分钟
          </span>
          <span>{article.publishedAt}</span>
        </div>
      </div>
    </Link>
  );
}